import React, { useContext, useEffect, useState } from 'react'
import { RealEstateDataPageComponentData } from 'types'
import { Col, Container, Row } from 'react-bootstrap'
import Card from 'react-bootstrap/Card'
import Accordion from 'react-bootstrap/Accordion'
import AccordionContext from 'react-bootstrap/AccordionContext'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import Loader from '@components/loader/1'

interface CTXAccordion {
    children?: any,
    eventKey: string,
    callback?: Function
}

const ContextAwareToggle = ({ children, eventKey, callback } :CTXAccordion) => {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <div className="d-flex justify-content-between align-itmes-center cursor-pointer card-header-wrapper" 
        onClick={decoratedOnClick}>
         <h3>{children}</h3>
         <i className={isCurrentEventKey ? "icon-line-light" : "icon-plus-light"}></i>
    </div>
  );
}

const MOCKDATA: RealEstateDataPageComponentData = {
  title: 'Preguntas frecuentes',
  subtitle:'Explorar las consultas:',
  faqs: [
    {
      question: "Quo quasi aspernatur aut expedita occaecati aliquamnec enim nam voluptate essitat?",
      answer: "Laudantium enim quasi est quidem magnam voluptate ipsam eos tempora quo quasi aspernatur aut expedita occaecati aliquamnec enim quasi est quidem magnam voluptate essitat."
    },
    {
      question: "Voluptate reprehenderit quasi aspernatur aut expedita occaecati aliquam eveniet?",
      answer: "Quia molestiae enim quasi est quidem magnam voluptate reprehenderit quasi aspernatur aut expedita occaecati aliquam eveniet laudantium omnis quibusdam delectus."
    },
    {
      question: "Below quasi aspernatur aut expedita occaecati aliquamas a natural lead-in?",
      answer: "With enim quasi est quidem magnam voluptate supporting text below quasi aspernatur aut expedita occaecati aliquamas a natural lead-in to additional content."
    },
    {
      question: "Wquas enim quasi est quidem magnam voluptate accusantium unde?",
      answer: "Wquas enim quasi est quidem magnam voluptate accusantium unde quasi aspernatur aut expedita occaecati aliquam odit nobis qui voluptatem quia voluptas consequuntur itaque."
    }
  ]
}

const Faq = (props: RealEstateDataPageComponentData) => {

  const { isDemo } = props
  const { title, subtitle, faqs } = isDemo ? MOCKDATA : props
  
  // Loader effect
  const [load, setLoad] = useState(true)
  useEffect(() => {
    setTimeout(() => {
      setLoad(() => false)
    }, 3000)
  }, [])

  return (
    <section id="faq-section" className={'faq p-y-config ' + (faqs?.length === 0 ? ' d-none' : '')}>
      <Container fluid>
        {
            !load ?
            <>
                <Row>
                <Col xs={12}>
                    <h2 className="section-title pb-lg-5">{title}</h2>
                </Col>
                <Col xs={12}>
                    <h3 className="section-subtitle pb-lg-3">{subtitle}</h3>
                </Col>
                </Row>
                <div className="faqs-wrapper my-4">
                    <Accordion flush>
                    {(faqs && faqs?.length > 0) ?
                        faqs?.map((qa,i) => (
                        <Accordion.Item eventKey={String(i)}>
                            <Card className="border-0">
                                <Card.Header className="ps-0">
                                    <ContextAwareToggle eventKey={String(i)}>
                                        {qa.question}
                                    </ContextAwareToggle>
                                </Card.Header>
                                <Accordion.Collapse eventKey={String(i)}>
                                    <Card.Body className="px-0">{qa.answer}</Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        </Accordion.Item>
                        )) : null }
                    </Accordion>
                </div>
            </>
            : <Loader />
        }
      </Container>
    </section>
  )
}

export default Faq
